import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Clapperboard, ArrowRight } from "lucide-react";
import api from "@/lib/api";

export default function CommunityGoalWidget() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/stats/community").then((r) => setData(r.data)).catch(() => {});
  }, []);
  if (!data) return null;
  const pct = Math.min(100, Math.round((data.videos / data.goal) * 100));

  return (
    <div className="border border-purple-500/25 rounded-md bg-purple-600/[0.07] p-5" data-testid="community-goal-widget">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div className="min-w-0">
          <p className="text-xs uppercase tracking-[0.15em] text-purple-300/80 flex items-center gap-1.5 mb-1">
            <Clapperboard className="h-3.5 w-3.5" /> Community goal
          </p>
          <p className="text-sm text-zinc-300">
            <span className="font-head font-bold text-white">{data.videos.toLocaleString()}</span>
            <span className="text-zinc-500"> / {data.goal.toLocaleString()} videos created</span>
            {" · "}🎁 <span className="text-purple-300 font-medium">+{data.bonus} credits for every member</span> when we hit it
          </p>
        </div>
        <Link to="/create" data-testid="community-widget-cta" className="shrink-0 text-sm text-purple-300 hover:text-purple-200 inline-flex items-center gap-1 font-semibold">
          Add yours <ArrowRight className="h-3.5 w-3.5" />
        </Link>
      </div>
      <div className="mt-3 h-2 rounded-full bg-white/5 overflow-hidden">
        <div className="h-full bg-gradient-to-r from-purple-600 to-purple-400 rounded-full transition-all duration-1000" style={{ width: `${Math.max(pct, 2)}%` }} />
      </div>
    </div>
  );
}
